var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g2, _path8, _path9, _path10, _path11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAzureContainerApp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_119)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_119)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 36,
    width: 180,
    height: 180,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 36.5,
    width: 179,
    height: 179,
    rx: 31.5,
    stroke: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_119",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 80,
    y: 76,
    width: 100,
    height: 100
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180 76H80.0001V176H180V76Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_119)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M173.732 107.678L167.673 105.565C166.568 103.284 165.225 101.129 163.671 99.1146C163.56 98.9467 163.448 98.8347 163.392 98.7228C164.889 98.1771 166.246 97.3236 167.393 96.2183C170.08 99.6882 172.221 103.55 173.732 107.678ZM148.616 81.3169C147.833 82.7021 147.329 84.2412 147.119 85.8223C147.007 85.7663 146.839 85.7104 146.727 85.6544C141.424 83.3177 135.688 82.1284 129.895 82.1564C117.19 82.1704 105.157 87.8791 97.1121 97.7154L95.503 98.0512C93.754 98.415 92.8586 99.4784 92.8306 101.269V103.83L87.1639 104.879C94.8314 88.1869 111.524 77.4831 129.895 77.4971C136.331 77.4831 142.712 78.7844 148.616 81.3169ZM99.8965 154.159C98.4973 154.928 97.294 155.992 96.3425 157.265C92.4808 153.319 89.3466 148.73 87.0659 143.707L92.8446 144.98V146.421C92.8306 148.212 93.6981 149.303 95.461 149.695L96.2446 149.863C97.28 151.304 98.4413 152.662 99.6866 153.921L99.8965 154.159ZM174.067 140.321C167.365 158.958 149.694 171.383 129.895 171.383C125.516 171.411 121.15 170.781 116.953 169.55C117.596 168.095 117.932 166.527 117.946 164.932C118.002 164.932 118.114 164.988 118.17 164.988C121.976 166.108 125.921 166.667 129.895 166.653C137.982 166.639 145.454 164.485 152.324 160.203C159.18 155.922 164.399 150.143 167.953 142.881L168.009 142.825L174.067 140.321Z",
    fill: "#39BCDB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M135.953 142.154L150.057 145.26L128.174 154.327C128.062 154.327 128.006 154.383 127.894 154.383C127.348 154.369 127.069 154.089 127.055 153.543V95.1549C127.069 94.6092 127.348 94.3294 127.894 94.3294C127.992 94.3154 128.09 94.3433 128.174 94.3853L152.954 103.046L136.009 106.208C134.414 106.572 133.603 107.566 133.561 109.203V139.201C133.561 140.852 134.344 141.832 135.953 142.154Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1143 107.496L92.8304 106.222V142.615L86.0024 141.104L80.5036 139.887C80.1398 139.817 79.9719 139.593 79.9999 139.215V109.217C79.9579 108.895 80.1818 108.601 80.5036 108.545L86.1143 107.496Z",
    fill: "#8C7AB7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M135.953 142.154L150.057 145.26L128.174 154.327C128.062 154.327 128.006 154.383 127.894 154.383C127.348 154.369 127.069 154.089 127.055 153.543V95.1549C127.069 94.6092 127.348 94.3294 127.894 94.3294C127.992 94.3154 128.09 94.3433 128.174 94.3853L152.954 103.046L136.009 106.208C134.414 106.572 133.603 107.566 133.561 109.203V139.201C133.561 140.852 134.344 141.832 135.953 142.154Z",
    fill: "url(#paint0_linear_1_119)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M127.698 94.3294L95.9927 100.318C95.475 100.43 95.2092 100.752 95.2092 101.297V146.449C95.2092 146.981 95.461 147.303 95.9647 147.415L127.67 154.341C128.454 154.494 128.846 154.173 128.832 153.375V95.3228C128.846 94.6652 128.524 94.3434 127.88 94.3294H127.698Z",
    fill: "url(#paint1_linear_1_119)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_119",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 97,
    width: 31,
    height: 54
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125.32 97.3236H95.9927V150.633H125.32V97.3236Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.4907 105.607V142.419L109.089 144.434V103.956L99.4907 105.607ZM113.049 103.34V145.358L124.088 147.191V101.353L113.049 103.34Z",
    fill: "#A794C6"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M168.89 87.3894C168.876 90.0758 167.925 92.3705 166.022 94.2734C164.119 96.1763 161.825 97.1137 159.124 97.1137C156.438 97.1137 154.143 96.1623 152.24 94.2594C150.337 92.3565 149.386 90.0618 149.386 87.3754C149.386 84.6889 150.337 82.3943 152.226 80.4914C154.115 78.5885 156.41 77.623 159.11 77.623C161.811 77.6091 164.119 78.5745 166.036 80.4774C167.953 82.3803 168.89 84.675 168.89 87.3894Z",
    fill: "#39BCDB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M115.609 164.737C115.609 167.437 114.658 169.746 112.741 171.649C110.838 173.551 108.529 174.517 105.829 174.517C103.129 174.517 100.82 173.565 98.917 171.649C97.0141 169.732 96.0486 167.437 96.0486 164.737C96.0486 162.036 97.0001 159.727 98.917 157.825C100.834 155.922 103.129 154.956 105.829 154.956C108.529 154.956 110.838 155.908 112.741 157.825C114.644 159.727 115.609 162.036 115.609 164.737Z",
    fill: "#39BCDB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M180 113.162V134.514C180.014 135.004 179.72 135.452 179.259 135.619L175.005 137.368L157.949 144.406H157.893C157.823 144.42 157.753 144.42 157.683 144.406C157.319 144.406 157.123 144.224 157.123 143.847V105.075C157.123 104.865 157.235 104.683 157.431 104.585H157.543C157.571 104.571 157.613 104.571 157.655 104.585C157.725 104.585 157.781 104.599 157.837 104.627H157.963L174.739 110.434L179.189 111.987C179.734 112.183 180.014 112.575 180 113.162Z",
    fill: "#5C4998"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M157.557 104.557L136.443 108.531C136.122 108.573 135.898 108.853 135.926 109.175V139.229C135.898 139.551 136.122 139.831 136.429 139.873L157.543 144.49C157.963 144.588 158.215 144.42 158.299 143.987C158.299 143.945 158.299 143.889 158.299 143.847V105.201C158.299 104.767 158.089 104.557 157.655 104.543C157.627 104.543 157.585 104.543 157.557 104.557Z",
    fill: "#8C7AB7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_119",
    x: 36,
    y: 36,
    width: 188,
    height: 188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_119"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_119",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_119",
    x: 0,
    y: 0,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_119"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_119",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_119",
    x1: 128.857,
    y1: 124.357,
    x2: 161.54,
    y2: 124.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C4998"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52378D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_119",
    x1: 112.023,
    y1: 96.9946,
    x2: 112.023,
    y2: 152.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C7AB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C4998"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureContainerApp);
export default __webpack_public_path__ + "static/media/azure-container-app.885e9c9ad437401c763dceeaca976235.svg";
export { ForwardRef as ReactComponent };